/* eslint-disable no-unused-vars*/
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import TemplateLimitComponents from 'components/TemplateLimit/templateLimit.components';
import { HasAccess } from '@permify/react-role';
import { ErrorPage404 } from 'common/Error/error.common';

const TemplateLimitPage = () => {
   return (
      <Fragment>
         <Helmet>
            <title>เทมเพลตเลขอั้น</title>
         </Helmet>
         <HasAccess
            roles={['Owner']}
            permissions={["period-list"]}
            renderAuthFailed={<ErrorPage404/>}
         >
            <TemplateLimitComponents/>
         </HasAccess>
      </Fragment>
   );
};

export default TemplateLimitPage;
